import gql from 'graphql-tag';

import type { AllInstructionsData, Language, TovInput } from 'src/data/generation';
import type { ImproveSectionInput } from 'src/data/longForm';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation CreateLongFormLocalizedDraft(
    $projectId: ID!
    $creationJobId: ID
    $sections: [ImproveSectionInput!]
    $language: String
    $tovInput: TovInput
    $structureInstructionsData: JSON
  ) {
    createLongFormLocalizedDraft(
      projectId: $projectId
      creationJobId: $creationJobId
      sections: $sections
      language: $language
      tovInput: $tovInput
      structureInstructionsData: $structureInstructionsData
    ) {
      id
    }
  }
`;

interface Variables extends GqlCallVariables {
  projectId: ID;
  creationJobId?: ID;
  sections: ImproveSectionInput[];
  language?: Language;
  tovInput?: TovInput;
  structureInstructionsData?: AllInstructionsData;
}

interface Result {
  id: ID;
}

export const createLongFormLocalizedDraft = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
